<template>
  <div class="box-div">
    <div>
      <div>招生类别：</div>
      <div>
        <div :class="item.isChoose ? 'active' : ''" @click="choose('categoryNameList', item)"
          v-for="(item, index) in categoryNameList" :key="index">{{
            item.projectCategoryName
          }}</div>
      </div>
    </div>
    <div class="line"></div>
    <div>
      <div>招生层次：</div>
      <div>
        <div :class="item.isChoose ? 'active' : ''" @click="choose('levelList', item)"
          v-for="(item, index) in levelList" :key="index">{{ item.value
          }}</div>
      </div>
    </div>
    <div class="line"></div>
    <div>
      <div>学习形式：</div>
      <div>
        <div :class="item.isChoose ? 'active' : ''" @click="choose('studyTypeList', item)"
          v-for="(item, index) in studyTypeList" :key="index">{{ item.value
          }}</div>
      </div>
    </div>
    <div class="line"></div>
    <div>
      <div>专科专业：</div>
      <div>
        <div :class="item.isChoose ? 'active' : ''" @click="choose('majorNameList', item)"
          v-for="(item, index) in majorNameList  " :key="index">{{
            item.majorName
          }}</div>
      </div>
    </div>
    <div class="line"></div>
    <div>
      <div>本科专业：</div>
      <div>
        <div :class="item.isChoose ? 'active' : ''" @click="choose('regularMajorNameList', item)"
          v-for="(item, index) in regularMajorNameList " :key="index">
          {{ item.majorName
          }}</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="last_result">
      <div class="result">
        <div style="flex-shrink: 0;">已选结果：</div>
        <div class="isChoose">
          <div @click="delChoose(item)" v-for="(item, index) in chooseList" :key="index"> <img
              src="~@/assets/img/TechnicalCollege/4.png" alt="">
            {{ item.name }}</div>
          <!-- <div style="background: none !important;">筛选出 <span>12</span> 条结果</div> -->
        </div>
      </div>
      <div style="background: none !important; flex-shrink: 0; ">
        <el-input @change="getLIst()" v-model="majorName"
          style="width: 260px; height: 30px;background: none !important;" placeholder=" 专业名称搜索">
          <i slot="append" class="el-input__icon el-icon-search" @click="paperchoose" />
        </el-input>
      </div>

    </div>

  </div>
</template>
<script>
import Vue from "vue";

import { Know } from "@/api/know";
let know = new Know();
export default {
  props: {
    testPaperType: {
      type: String,
    },
  },
  data() {
    return {
      search: {
        name: ''
      },
      majorName: '',
      imgList: {},
      categoryNameList: [],
      levelList: [],
      majorNameList: [],
      regularMajorNameList: [],
      studyTypeList: [],
      chooseList: [],
      projectType: ''
    };
  },
  async created() {
    this.projectType = localStorage.getItem('projectType');

    this.getTuitionPcFiltrateList()

  },
  methods: {
    getTuitionPcFiltrateList() {
      know.getTuitionPcFiltrateLists({ projectType: this.projectType }).then((res) => {
        this.categoryNameList = res.data.categoryNameList
        this.categoryNameList.unshift({ projectCategoryName: '全部' })
        this.levelList = res.data.levelList
        this.levelList.unshift({ value: '全部' })
        this.majorNameList = res.data.majorNameList
        this.majorNameList.unshift({ majorName: '全部' })
        this.regularMajorNameList = res.data.regularMajorNameList
        this.regularMajorNameList.unshift({ majorName: '全部' })
        this.studyTypeList = res.data.studyTypeList
        this.studyTypeList.unshift({ value: '全部' })
        this.categoryNameList.forEach(e => {
          if (e.projectCategoryName == '全部') {
            e.isChoose = true
          } else {
            e.isChoose = false

          }
        });
        this.levelList.forEach(e => {
          if (e.value == '全部') {
            e.isChoose = true
          } else {
            e.isChoose = false

          }
        });
        this.studyTypeList.forEach(e => {
          if (e.value == '全部') {
            e.isChoose = true
          } else {
            e.isChoose = false
          }
        });
        this.majorNameList.forEach(e => {
          if (e.majorName == '全部') {
            e.isChoose = true
          } else {
            e.isChoose = false
          }
        });
        this.regularMajorNameList.forEach(e => {
          if (e.majorName == '全部') {
            e.isChoose = true
          } else {
            e.isChoose = false
          }
        });

      });
    },
    choose(name, item) {
      if (name == 'categoryNameList') {
        this.replaceItem({ name: item.projectCategoryName, id: item.projectCategoryId, sname: name })
        // this.chooseList.push({ name: item.projectCategoryName, id: item.projectCategoryId, sname: name })
      } else if (name == 'levelList') {
        this.replaceItem({ name: item.value, id: item.key, sname: name })
      } else if (name == 'studyTypeList') {
        this.replaceItem({ name: item.value, id: item.value, sname: name })
      } else if (name == 'majorNameList') {
        this.replaceItem({ name: item.majorName, id: item.majorId, sname: name })
      } else if (name == 'regularMajorNameList') {
        this.replaceItem({ name: item.majorName, id: item.majorId, sname: name })
      }
      this.replaceItems(name, item)
    },
    replaceItem(newItem) {
      const index = this.chooseList.findIndex(item => item.sname == newItem.sname);
      if (index !== -1) {
        this.$set(this.chooseList, index, newItem);
      }
      else {
        this.chooseList.push(newItem)
      }
      this.chooseList = this.chooseList.filter(item => item.name != '全部');
      this.$emit('chooseList', this.chooseList)
      this.$forceUpdate()
    },
    replaceItems(name, newItem) {
      const index = this.chooseList.findIndex(item => item.sname == name);
      if (index !== -1) {
        if (name == 'categoryNameList') {
          const indexs = this.chooseList.findIndex(item => item.id == newItem.projectCategoryId);
          if (indexs !== -1) {
            this.categoryNameList.forEach(e => {
              e.isChoose = false
            });
            newItem.isChoose = true
          } else {
            newItem.isChoose = false
          }
        } else if (name == 'levelList') {
          const indexs = this.chooseList.findIndex(item => item.id == newItem.value);
          if (indexs !== -1) {
            this.levelList.forEach(e => {
              e.isChoose = false
            });
            newItem.isChoose = true
          } else {
            newItem.isChoose = false
          }
        } else if (name == 'studyTypeList') {
          const indexs = this.chooseList.findIndex(item => item.id == newItem.value);
          if (indexs !== -1) {
            this.studyTypeList.forEach(e => {
              e.isChoose = false
            });
            newItem.isChoose = true
          } else {
            newItem.isChoose = false
          }
        } else if (name == 'majorNameList') {
          const indexs = this.chooseList.findIndex(item => item.id == newItem.majorId);
          if (indexs !== -1) {
            this.majorNameList.forEach(e => {
              e.isChoose = false
            });
            newItem.isChoose = true
          } else {
            newItem.isChoose = false
          }
        } else if (name == 'regularMajorNameList') {
          const indexs = this.chooseList.findIndex(item => item.id == newItem.majorId);
          if (indexs !== -1) {
            this.regularMajorNameList.forEach(e => {
              e.isChoose = false
            });
            newItem.isChoose = true
          } else {
            newItem.isChoose = false
          }
        }


      }
      else {
        if (newItem.projectCategoryName == '全部' || newItem.value == '全部' || newItem.majorName == '全部') {
          if (name == 'categoryNameList') {
            this.categoryNameList.forEach(e => {
              e.isChoose = false
            });
          } else if (name == 'levelList') {
            this.levelList.forEach(e => {
              e.isChoose = false
            });

          } else if (name == 'studyTypeList') {
            this.studyTypeList.forEach(e => {
              e.isChoose = false
            });

          } else if (name == 'majorNameList') {
            this.majorNameList.forEach(e => {
              e.isChoose = false
            });

          } else if (name == 'regularMajorNameList') {
            this.regularMajorNameList.forEach(e => {
              e.isChoose = false
            });
          }
          newItem.isChoose = true
        } else {
          newItem.isChoose = false
        }
      }
    },
    paperchoose() {
      this.$emit('majorName', this.majorName)
    },
    delChoose(items) {

      const index = this.chooseList.findIndex(item => item.id == items.id);
      if (index !== -1) {
        this.chooseList.splice(index, 1);
      }
      if (items.sname == 'categoryNameList') {
        this.categoryNameList.forEach(e => {
          if (e.projectCategoryName == '全部') {
            e.isChoose = true
          } else {
            e.isChoose = false

          }
        });
      } else if (items.sname == 'levelList') {
        this.levelList.forEach(e => {
          if (e.value == '全部') {
            e.isChoose = true
          } else {
            e.isChoose = false

          }
        });

      } else if (items.sname == 'studyTypeList') {
        this.studyTypeList.forEach(e => {

          if (e.value == '全部') {
            e.isChoose = true
          } else {
            e.isChoose = false

          }
        });

      } else if (items.sname == 'majorNameList') {
        this.majorNameList.forEach(e => {
          if (e.majorName == '全部') {
            e.isChoose = true
          } else {
            e.isChoose = false

          }
        });

      } else if (items.sname == 'regularMajorNameList') {
        this.regularMajorNameList.forEach(e => {
          if (e.majorName == '全部') {
            e.isChoose = true
          } else {
            e.isChoose = false

          }
        });
      }
    }

  },
};
</script>
<style lang="less" scoped>
.box-div {
  width: 1200px;
  // height: 300px;
  background: #FFFFFF;
  border-radius: 3px 3px 3px 3px;
  padding: 20px;

  >div {
    font-family: PingFangSC-Regular, PingFangSC-Regular;
    font-weight: normal;
    font-size: 16px;
    color: #555555;
    display: flex;
    align-items: baseline;

    >div:nth-child(1) {
      flex-shrink: 0;

    }

    >div:nth-child(2) {

      display: flex;
      flex-wrap: wrap;

      >div {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: normal;
        font-size: 14px;
        color: #333333;
        padding: 4px 15px;
        margin-right: 20px;
        cursor: pointer;
        border-radius: 4px 4px 4px 4px;
      }

      >div:hover {
        background: #F3F7FF;
        color: #3D6CC8;
      }

      .active {
        background: #F3F7FF;
        color: #3D6CC8;
      }
    }
  }
}

.line {
  width: 100%;
  height: 0px;
  border-bottom: 1px solid #EEEEEE;
  margin: 9px 0;
}

.result {
  font-family: PingFangSC-Regular, PingFangSC-Regular;
  font-weight: normal;
  font-size: 16px;
  color: #555555;
  display: flex;
  align-items: baseline;

  >div:nth-child(1) {
    flex-shrink: 0;

  }

  >div:nth-child(2) {

    display: flex;
    flex-wrap: wrap;

    >div {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: normal;
      font-size: 14px;
      color: #333333;
      padding: 4px 15px;
      margin-right: 20px;
      cursor: pointer;
      border-radius: 4px 4px 4px 4px;
    }

    >div:hover {
      background: #F3F7FF;
      color: #3D6CC8;
    }
  }
}

.isChoose {
  display: flex;
  flex-wrap: wrap;
  width: 700px;

  >div {
    background: #EEEEEE;
    font-family: PingFangSC-Regular, PingFangSC-Regular;
    font-weight: normal;
    font-size: 14px !important;
    color: #555555 !important;
    border-radius: 4px 4px 4px 4px;
    position: relative;
    margin-bottom: 10px;

    img {
      width: 12px;
      height: auto;
      position: absolute;
      right: -3px;
      top: -3px;
    }

  }

  >div:hover {
    background: #EEEEEE !important;
    color: #555555 !important;
  }




}

.last_result {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

::v-deep .el-input-group__append {
  padding: 0 7px;
  height: 30px;
  vertical-align: baseline;
  background: #3D6CC8;
  color: #fff;
  font-size: 14px;
}

::v-deep .el-input__inner {
  height: 30px;

}

::v-deep .el-input__icon {
  line-height: 30px;

}
</style>
